<template>
    <page-loading-animation v-if="isLoading" :is-loading="isLoading" />

    <div v-else>
        <!--No Notices Message-->
        <div v-if="!noticeBoardData.length">
            <app-text>You have no Notices to view</app-text>
        </div>

        <!-- <div class="rounded-lg mb-4" :style="`border-left: 16px solid red`"> -->
        <!-- <div class="appWhite pa-4"> -->
        <!-- Title | Date -->
        <!-- <div style="width: 100%"> -->
        <!-- Title | Date -->
        <!-- <div class="d-flex align-center justify-space-between"> -->
        <!-- Title -->
        <!-- <app-text size="normal-bold"> -->
        <!-- Welcome to the Media Accreditation procedure for the 'GUINNESS SIX NATIONS 2025’ WALES HOME FIXTURES AT PRINCIPALITY -->
        <!-- STADIUM -->
        <!-- </app-text> -->
        <!-- </div> -->
        <!-- Description -->
        <!-- <app-text class="mt-2"> -->
        <!-- Round 3 - SATURDAY, 22 FEBRUARY - WALES v IRELAND (14.15pm)<br /> -->
        <!-- Round 5 - SATURDAY, 15 MARCH - WALES v ENGLAND (16.45pm)<br /> -->
        <!-- • Please note the deadline for media accreditation Is 10 working days prior to match day (unless otherwise stated). Requests -->
        <!-- made after the deadline will not be accepted.<br /> -->
        <!-- • All photographers, written media and non-rights holders must apply through this portal.<br /> -->
        <!-- • Please note ALL photographers must read the Photographers Agreement. By clicking to accept T&Cs you are bound by the -->
        <!-- regulations within the agreement. <br /> -->
        <!-- If you have any questions at this stage please contact Phil Giouras -->
        <!-- <span><a href="mailto:pgiouras@wru.wales">pgiouras@wru.wales</a></span> or Anna Chapman -->
        <!-- <span><a href="mailto:achapman@wru.wales">achapman@wru.wales</a></span> -->
        <!-- </app-text> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!--Notice Cards-->
        <div
            v-for="item in computedNoticeBoardData"
            :key="item.entityId"
            class="rounded-lg mb-4"
            :style="`border-left: 16px solid ${getNoticeColor(item.noticePriority)}`"
        >
            <div class="appWhite pa-4">
                <!--Title | Date-->
                <div style="width: 100%">
                    <!--Title | Date-->
                    <div class="d-flex align-center justify-space-between">
                        <!--Title-->
                        <app-text size="normal-bold">{{ item.noticeTitle }}</app-text>

                        <!--Date Posted-->
                        <app-text color="grey9" size="small">
                            {{ MIX_formatDate(Number(item.createdDateTime), 'numeric') }}
                        </app-text>
                    </div>

                    <!--Description-->
                    <div class="mt-2 notice-description" v-html="item.noticeDescription"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoticeBoardWidget',

    data: () => ({
        isLoading: false,

        // Data
        noticeBoardData: []
    }),

    computed: {
        /**
         * Computed Notice Board Data
         *
         * Check what type of noticeSendToType the notice is, and display/hide it accordingly.
         * Sort the notices by date (newest first), but all 'high' priority notices should be at the top.
         */
        computedNoticeBoardData() {
            const t = this
            const CURRENT_USER_DATA = t.MIX_getCurrentUser()
            const NOTICE_DATA = t.noticeBoardData
            let noticeData = []

            // Loop through all the notices
            NOTICE_DATA.forEach((notice) => {
                if (notice.noticeVisibility === 'Hidden') return

                // Users
                if (notice.noticeSendToType === 'Users' && notice.noticeSendToListUsers.includes(CURRENT_USER_DATA.entityId)) noticeData.push(notice)

                // User Levels
                if (notice.noticeSendToType === 'Levels' && notice.noticeSendToListLevels.includes(CURRENT_USER_DATA.userLevel))
                    noticeData.push(notice)

                // User Types
                if (notice.noticeSendToType === 'Types' && notice.noticeSendToListTypes.includes(CURRENT_USER_DATA.userType)) noticeData.push(notice)

                // All
                if (notice.noticeSendToType === 'All') noticeData.push(notice)
            })

            // Sort the notices by date (newest first), but all 'high' priority notices should be at the top
            noticeData.sort((a, b) => {
                return a.noticePriority === 'High' ? -1 : b.noticePriority === 'High' ? 1 : b.createdDateTime - a.createdDateTime
            })

            return noticeData
        }
    },

    methods: {
        /**
         * Get Notice Color
         *
         * Return the color of the notice based on its priority.
         *
         * @param noticePriority {string} the priority of the notice
         * @returns {string} the color of the notice
         */
        getNoticeColor(noticePriority) {
            let noticeColor = 'grey'

            switch (noticePriority) {
                case 'High':
                    noticeColor = 'red'
                    break
                case 'Medium':
                    noticeColor = 'orange'
                    break
                case 'Low':
                    noticeColor = 'green'
                    break
                default:
                    noticeColor = 'grey'
            }

            return noticeColor
        },

        /**
         * Load Data
         *
         * Load all the data required for the page.
         *
         * @returns {Promise<void>}
         */
        async loadData() {
            const t = this

            t.isLoading = true

            await Promise.all([
                await t.loadNoticeBoardData()
                // await t.loadCurrentUserData()
            ])

            t.isLoading = false
        },

        /**
         * Load Notice Board Data
         *
         * Load the required data from the database.
         *
         * @returns {Promise<void>}
         */
        async loadNoticeBoardData() {
            const t = this

            const RESPONSE = await t.MIX_redis_getAll('noticeBoard')

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error getting Notice Board data: ', RESPONSE.error)
                t.$sharedState.errorMessage = 'There was a problem loading the Notice Board, please try again.'
                return
            }

            // Assign the data
            t.noticeBoardData = RESPONSE.data
        }
    },

    created() {
        const t = this

        t.loadData()
    }
}
</script>

<style scoped>
.notice-description ::v-deep p {
    margin: 0;
    line-height: 1.5;
}

.notice-description ::v-deep p + p {
    margin-top: 0.5em;
}

.notice-description ::v-deep .ql-align-center {
    text-align: center;
}

.notice-description ::v-deep .ql-align-right {
    text-align: right;
}

.notice-description ::v-deep .ql-align-left {
    text-align: left;
}

.notice-description ::v-deep .ql-align-justify {
    text-align: justify;
}
</style>
